import './conversations.css';

import { Button } from '@mui/material';
// import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import DialogChatterInvitation from '../../Components/Dialogs/DialogChatterInvitation';
import useAuth from '../../hooks/useAuth';
// import { Route,Routes } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useRole from '../../hooks/useRole';
import Contact from './Contacts';
// import Conversation from './Conversation';

function Conversations() {
    // Conversations.propTypes = {
    //     role: PropTypes.any,
    // };{ role }
    // let user;
    const {auth} = useAuth();
    const role = useRole();
    const axiosPrivate = useAxiosPrivate();
    const [chatList, setchatList] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [openChatter, setOpenChatter] = useState(false);
    const getChatList = async ()=> {
        axiosPrivate
            .get('/conversation/chatList')
            .then(function (response) {
                if(Array.isArray(response?.data))
                    setchatList(response.data.reverse());
                setLoaded(true);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        getChatList();
    }, []);

    return (
        <div className="container">
            {/* <h3 className="text-center">Conversations</h3> */}

            <div className="messaging">
                <div className="inbox_msg">
                    <div className="inbox_people">
                        <div className="headind_srch">
                            <div className="recent_heading">
                                <h4>Recent</h4>
                            </div>
                            <div className="srch_bar">
                                {/* //* search bar */}
                                {/* <div className="stylish-input-group">
                                    <input
                                        type="text"
                                        className="search-bar"
                                        placeholder="Search"
                                    ></input>
                                    <span className="input-group-addon">
                                        <button type="button">
                                            {' '}
                                            <i
                                                className="fa fa-search"
                                                aria-hidden="true"
                                            ></i>{' '}
                                        </button>
                                    </span>{' '}
                                </div> */}
                                {role=='admin' &&
                                <Button onClick={()=> setOpenChatter(true)}>
                                    chatter avec un Utilisateur
                                </Button>}
                            </div>
                        </div>
                        <div className="inbox_chat">
                            {loaded
                                ? chatList.map((chat) => {
                                    console.log(chatList);
                                    return (
                                        <Contact
                                            role={role}
                                            key={chat?.to._id}
                                            id={
                                                chat?.user._id == auth?.userId
                                                    ? chat?.to._id
                                                    : chat?.user._id
                                            }
                                            username={
                                                chat?.user._id == auth?.userId
                                                    ? chat?.to.userName
                                                    : chat?.user.userName
                                            }
                                            to={chat?.to}
                                            time={chat?.chats[chat?.chats.length - 1].time.toString()}
                                            lastMsg={
                                                chat?.chats[chat?.chats.length - 1].message
                                            }
                                        />
                                    );
                                }) : ''}
                        </div>
                    </div>
                    <div className="mesgs">
                        <div className="msg_history">
                            {/* <Routes>
                                <Route
                                    path={'/conversation/:to'}
                                    element={<Conversation />}
                                />
                                <Route
                                    path={'/conversation'}
                                    element={<div></div>}
                                />
                            </Routes> */}
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            {
                openChatter &&
                <DialogChatterInvitation
                    openChatter={openChatter}
                    handleOpenChatter={()=>{
                        setOpenChatter(false);
                        getChatList();
                    }}
                />
            }
        </div>
    );
}
export default Conversations;